import { createContext, type PropsWithChildren, useContext, useMemo } from "react";

import { useAuth } from "../auth/auth-context.js";
import { createTradingEngineClient, type TradingEngineClient } from "./client.js";

const ApiContext = createContext<TradingEngineClient | null>(null);

interface ApiProviderProps extends PropsWithChildren {
  readonly baseUrl: string;
}

export function ApiProvider({ baseUrl, children }: ApiProviderProps) {
  const auth = useAuth();
  const client = useMemo(
    () =>
      createTradingEngineClient({
        baseUrl,
        getAccessToken: auth.getAccessToken,
        onUnauthorized: auth.expireSession,
      }),
    [auth.expireSession, auth.getAccessToken, baseUrl],
  );
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): TradingEngineClient {
  const client = useContext(ApiContext);
  if (client === null) throw new Error("useApi must be used inside ApiProvider.");
  return client;
}
